import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class TextFactory extends AbstractShapeFactory {

  private fontSize = 20;

  constructor() {
    super();
    this.awType = 'text';
    this.parentButton = WBUtils.buttonBasic;
  }

  /**
     * Creates and returns a fabric text object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    this.shapeObject = new fabric.Text('___', {
      left: anchorX,
      top: anchorY - this.fontSize,
      fontSize: this.fontSize,
      fontFamily: 'sans-serif',
      backgroundColor: '#fff',
      selectable: false,
      fill: color
    });

    return this.shapeObject;
  }

  /**
     * modifies the text object expanding it to position (eventX/eventY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    this.shapeObject.set({ left: eventX });
    this.shapeObject.set({ top: eventY });
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
